"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Mixin;
exports.WithDefault = WithDefault;
exports.Cached = Cached;
exports.HasInstance = HasInstance;
exports.ApplyDefault = ApplyDefault;
exports.Dedupe = Dedupe;

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime/core-js/object/get-own-property-descriptor"));

var _getPrototypeOf = _interopRequireDefault(require("@babel/runtime/core-js/object/get-prototype-of"));

var _defineProperty = _interopRequireDefault(require("@babel/runtime/core-js/object/define-property"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime/core-js/object/get-own-property-symbols"));

var _hasInstance = _interopRequireDefault(require("@babel/runtime/core-js/symbol/has-instance"));

var _symbol = _interopRequireDefault(require("@babel/runtime/core-js/symbol"));

var _weakMap = _interopRequireDefault(require("@babel/runtime/core-js/weak-map"));

var _ = _interopRequireDefault(require("./"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Mixin(factory, Default) {
  factory = Cached(factory);
  factory = HasInstance(factory);
  factory = Dedupe(factory);
  factory = WithDefault(factory, Default || (0, _.default)());
  factory = ApplyDefault(factory);
  return factory();
}

function WithDefault(classFactory, Default) {
  return function (Base) {
    Base = Base || Default;
    return classFactory(Base);
  };
}

function Cached(classFactory) {
  var classCache = new _weakMap.default();
  return function (Base) {
    var Class = classCache.get(Base);

    if (!Class) {
      classCache.set(Base, Class = classFactory(Base));
    }

    return Class;
  };
}

function HasInstance(classFactory) {
  var instanceofSymbol;
  return function (Base) {
    var Class = classFactory(Base);

    if (typeof _symbol.default === 'undefined' || !_hasInstance.default) {
      return Class;
    }

    if ((0, _getOwnPropertySymbols.default)(Class).indexOf(_hasInstance.default) !== -1) {
      return Class;
    }

    if (!instanceofSymbol) {
      instanceofSymbol = (0, _symbol.default)('instanceofSymbol');
    }

    Class[instanceofSymbol] = true;
    (0, _defineProperty.default)(Class, _hasInstance.default, {
      value: function (obj) {
        // we do this check because a subclass of `Class` may not have
        // it's own `[Symbol.hasInstance]()` method, therefore `this`
        // will be the subclass, not this `Class`, when the prototype
        // lookup on the subclass finds the `[Symbol.hasInstance]()`
        // method of this `Class`. In this case, we don't wsnt to run
        // our logic here, so we delegate to the super class of this
        // `Class` to take over with the instanceof check. In many
        // cases, the super class `[Symbol.hasInstance]()` method will
        // be `Function.prototype[Symbol.hasInstance]` which will
        // perform the standard check.
        if (this !== Class) // This is effectively a `super` call.
          {
            return (0, _getPrototypeOf.default)(Class)[_hasInstance.default].call(this, obj);
          }

        var currentProto = obj;

        while (currentProto) {
          var descriptor = (0, _getOwnPropertyDescriptor.default)(currentProto, "constructor");

          if (descriptor && descriptor.value && descriptor.value.hasOwnProperty(instanceofSymbol)) {
            return true;
          }

          currentProto = (0, _getPrototypeOf.default)(currentProto);
        }

        return false;
      }
    });
    return Class;
  };
} // requires WithDefault or a classFactory that can accept no args


function ApplyDefault(classFactory) {
  var DefaultClass = classFactory();
  DefaultClass.mixin = classFactory;
  return classFactory;
} // requires Cached


function Dedupe(classFactory) {
  var map = new _weakMap.default();
  return function (Base) {
    if (hasMixin(Base, classFactory, map)) {
      return Base;
    }

    var Class = classFactory(Base);
    map.set(Class, classFactory);
    return Class;
  };
}

function hasMixin(Class, mixin, map) {
  while (Class) {
    if (map.get(Class) === mixin) {
      return true;
    }

    Class = Class.__proto__;
  }

  return false;
}